import { openModal } from '../../../events'

export const clickList = {
  malware: (malware) => openModal('MalwareModal', malware.id, malware.name),
  'threat-actor': (actor) => openModal('ActorModal', actor.id, actor.name),
  campaign: (campaign) => openModal('CampaignModal', campaign.id, campaign.name),
}

export const statusIcons = (num) => {
  if (num <= 40) return { color: 'colorRiskLow', iconName: 'check-circle' }
  if (num < 80) return { color: 'colorTextDeemphasis', iconName: 'help-circle' }
  return { color: 'colorRiskCritical', iconName: 'alert-triangle-fill' }
}

export const iconTypes = {
  'threat-actor': 'user-secret',
  malware: 'bug',
  campaign: 'bullseye'
}

export const typeDisplayMap = {
  fqdn: 'FQDN',
  ipv4: 'IPV4',
  md5: 'Hash',
  sha1: 'Hash',
  sha256: 'Hash',
  url: 'URL',
}

export const severityColorByThreatScore = (value) => {
  if (value === 0) return severityColorMap.benign
  if (value >= 1 && value <= 40) return severityColorMap.low
  if (value > 40 && value <= 60) return severityColorMap.medium
  if (value > 60 && value <= 100) return severityColorMap.high
  if (!value || value > 100) return severityColorMap.benign
}

export const statusIconByThreatScore = (value) => {
  if (value === 0) return 'alert-circle'
  if (value >= 1 && value <= 40) return 'alert-triangle'
  if (value > 40 && value <= 60) return 'alert-diamond'
  if (value > 60 && value <= 100) return 'alert-octagon'
  if (!value || value > 100) return 'alert-circle'
}

export const severityColorMap = {
  unknown: 'var(--maui-color-risk-benign)',
  benign: 'var(--maui-color-risk-benign)',
  low: 'var(--maui-color-risk-low)',
  medium: 'var(--maui-color-risk-medium)',
  high: 'var(--maui-color-risk-critical)',
  circleBenign: 'var(--maui-color-risk-background-benign)',
  circleLow: 'var(--maui-color-risk-background-low)',
  circleMedium: 'var(--maui-color-risk-background-medium)',
  circleHigh: 'var(--maui-color-risk-background-critical)',
}
